<div class="mypanel">
	<div
		class="mb-4 flex transform cursor-pointer flex-row flex-wrap items-center bg-white p-4 font-semibold text-gray-800 shadow-lg transition duration-500 ease-in-out hover:-translate-y-1 hover:shadow-xl"
		(click)="toggle.emit()"
	>
		<span class="flex-1">{{ title }}</span>
		<i class="flex h-6 w-6 transform items-center justify-center transition duration-500 ease-in-out" [ngClass]="{ 'rotate-180': opened }">
			<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" class="h-6 w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
				<path
					fill="currentColor"
					d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"
				></path>
			</svg>
		</i>
	</div>
	<div class="text-gray-700" [ngClass]="{ 'hidden': !opened }">
		<ng-content></ng-content>
	</div>
</div>
